import { useEffect, useState } from 'react';
import ROTYTrophy from '../../uber-assets/small-trophy-logo.svg';
import { ALL_AREAS, AREAS_BUTTON_ORDER, DEFAULT_REGION_ID } from '../model/areas';
import { GetFinalists, GetRestaurantsByRegion, GetWinners } from '../model/restaurants';
import { RestaurantCard } from './restaurant-card/restaurant-card';
import nl2br from 'react-nl2br';
import { PHASES } from '../model/phases';
import { WinnerCard } from './winner-card/winner-card';
import { ROTY_WINNER_ICON } from '../../uber-assets/inline-svgs';

import ROTYBadgeAnim from '../../uber-assets/roty-badge.json';
import Lottie from 'react-lottie';
import { EMPTY_TRAILBLAZER } from '../model/trailblazer-nominees';

export function ROTYSection({showRestaurantInfo, instagramFunction, orderFunction, voteFunction, phase, votes, initialRegion, cardTransitionInFunction, cardTransitionOutFunction, scrollAnimInHandler}) {
    const [activeRegion, setActiveRegion] = useState(initialRegion || DEFAULT_REGION_ID);
    const [nextRegion, setNextRegion] = useState(null);
    const [switchingRegion, setSwitchingRegion] = useState(false);
    const SHOW_ALL_GROUP_SIZE = 6;
    const [showAllCount, setShowAllCount] = useState(SHOW_ALL_GROUP_SIZE);
    const switchRegion = (regionId) => {
        if (!switchingRegion) {
            const switchRegionNow = () => {
                setActiveRegion(regionId);
                setSwitchingRegion(false);
                setShowAllCount(SHOW_ALL_GROUP_SIZE);
                setTimeout(() => {
                    cardTransitionInFunction('restaurant-card-anim');
                }, 100);
            }

            setSwitchingRegion(true);
            setNextRegion(regionId);
            cardTransitionOutFunction('restaurant-card-anim', switchRegionNow);
        }
    }
    const showMore = () => {
        setShowAllCount((oldVal) => {let newVal = oldVal + SHOW_ALL_GROUP_SIZE; return newVal;});
        if (scrollAnimInHandler) {
            setTimeout(() => {
                scrollAnimInHandler?.();
            }, 100);
        }
    }

    const showFinalists = phase === PHASES.FINALISTS || phase === PHASES.WINNERS;
    const showWinner = phase === PHASES.WINNERS;

    const [regionRestaurants, setRegionRestaurants] = useState([]);
    useEffect(() => {
        // Fetch restaurants for active region
        setRegionRestaurants(showFinalists ? GetFinalists() : GetRestaurantsByRegion(activeRegion));
    }, [activeRegion, phase]);

    useEffect(() => {
        if (initialRegion) {
            setActiveRegion(initialRegion);
        }
    }, [initialRegion]);

    const winner = GetWinners()[0];

    return (
        <section className="roty-section" id="roty">
            <div className="section-container">
                <div className='content'>
                    <div className="column roty-section-heading">
                        {!showFinalists &&
                            <>
                                <div className="section-image-heading-container">
                                    {/* <img className='section-heading-image' src={ROTYTrophy} alt="Restaurant of the Year" /> */}
                                    {/* <div className='section-heading-image'>
                                        <Lottie
                                            options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: ROTYBadgeAnim,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                zIndex: 1,
                                            }}
                                        />
                                    </div> */}
                                    {phase === PHASES.VOTE &&
                                        <h1>Vote For Your Restaurant Of The Year</h1>
                                    }
                                    {phase === PHASES.VOTE_ENDED &&
                                        <h1>Learn more about the nominees</h1>
                                    }
                                    {phase === PHASES.FINALISTS &&
                                        <h1>Meet your regional winners</h1>
                                    }
                                    {phase === PHASES.WINNERS &&
                                        <h1>Restaurant of the Year 2026</h1>
                                    }
                                </div>
                                {/* <p>Find below our 130 Finalists from 12 Regions within the UK and Ireland, all eligible to become the 2024 Uber Eats Restaurant of the Year.</p> */}

                                <div className='cat-buttons-container'>
                                    {AREAS_BUTTON_ORDER.map((area, index) => {
                                        return (
                                            <button className={`cat-button region${((area.area.id === activeRegion && !switchingRegion) || (area.area.id === nextRegion && switchingRegion)) ? ' active' : ''}`} key={index} onClick={(e) => switchRegion(area.area.id)} disabled={area.area.id === activeRegion}>{(area?.buttonLabel ?? area.label)}</button>
                                        )
                                    })}
                                </div>
                                <select className='cat-drop-down' onChange={(e) => switchRegion(e.target.value)} value={activeRegion}>
                                    {AREAS_BUTTON_ORDER.map((area, index) => {
                                        return (
                                            <option key={index} value={area.area.id}>{area.label}</option>
                                        )
                                    })}
                                </select>
                            </>
                        }
                        {showFinalists && !showWinner &&
                            <>
                                <div className="section-image-heading-container">
                                    {/* <img className='section-heading-image' src={ROTYTrophy} alt="Restaurant of the Year" /> */}
                                    {/* <div className='section-heading-image'>
                                        <Lottie
                                            options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: ROTYBadgeAnim,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                zIndex: 1,
                                            }}
                                        />
                                    </div> */}
                                    {phase === PHASES.FINALISTS &&
                                        <h1>Meet your regional winners</h1>
                                    }
                                    {phase === PHASES.WINNERS &&
                                        <h1>Restaurant of the Year 2026</h1>
                                    }
                                </div>
                                <p className='subheading extra-bottom-pad'>Meet the 9 incredible regional winners, chosen by popular vote, now in the running to be crowned the 2026 Uber Eats Restaurant of the Year. Check them out below to celebrate the best of the UK’s food scene, and see who's one step closer to taking the national win!</p>
                            </>
                        }
                        {showWinner &&
                            <>
                                <div className="section-image-heading-container">
                                    {/* <img className='section-heading-image' src={ROTYTrophy} alt="Restaurant of the Year" /> */}
                                    {/* <div className='section-heading-image'>
                                        <Lottie
                                            options={{
                                                loop: true,
                                                autoplay: true,
                                                animationData: ROTYBadgeAnim,
                                                rendererSettings: {
                                                    preserveAspectRatio: 'xMidYMid slice'
                                                }
                                            }}
                                            style={{
                                                width: '100%',
                                                height: 'auto',
                                                zIndex: 1,
                                            }}
                                        />
                                    </div> */}
                                    <h1>MEET THIS YEAR'S NATIONAL WINNER:</h1>
                                </div>
                                <div className='section-image-heading-container'>
                                    <h1 className='big white'>{winner.name}</h1>
                                </div>
                                {/*<div>
                                    <p>{winner.name} has been crowned Uber Eats Restaurant of the Year 2025, impressing an expert panel of judges and winning a £100,000 cash prize to invest in their business.</p>
                                    <p>A huge congratulations to {winner.name} and all of the amazing finalists this year.</p>
                                </div>*/}
                                {GetWinners().map((winner, index) => {
                                    return (
                                        <WinnerCard key={index} icon={ROTY_WINNER_ICON} category="Restaurant of the Year 2026" winner={winner} showRibbon={false} infoFunction={showRestaurantInfo} instagramFunction={instagramFunction} orderFunction={orderFunction} />
                                    )
                                })}
                                <div className="cards-container">
                                    <RestaurantCard key={'rwin_1'} showBigRibbon={true} position={2} bigCard={true} trailblazer={EMPTY_TRAILBLAZER} infoFunction={showRestaurantInfo} instagramFunction={() => {}} orderFunction={() => {}} finalist={() => {}} showWinner={() => {}} />
                                    <RestaurantCard key={'rwin_2'} showBigRibbon={true} position={3} bigCard={true} trailblazer={EMPTY_TRAILBLAZER} infoFunction={showRestaurantInfo} instagramFunction={() => {}} orderFunction={() => {}} finalist={() => {}} showWinner={() => {}} />
                                </div>
                                <div>
                                    <div className='extra-bottom-pad'></div>
                                    <h1 className='extra-bottom-pad'>Our regional winners</h1>
                                </div>
                            </>
                        }
                    </div>
                </div>
                <div className="cards-container">
                    {regionRestaurants.map((restaurant, index) => {
                        if (activeRegion === ALL_AREAS.id && !showFinalists && !showWinner && index >= showAllCount) {
                            return null; // Skip rendering if not showing all
                        }
                        return (
                            <RestaurantCard key={index} restaurant={restaurant} infoFunction={showRestaurantInfo} instagramFunction={instagramFunction} orderFunction={orderFunction} voteFunction={voteFunction} phase={phase} alreadyVoted={votes.indexOf(restaurant.id) !== -1} finalist={showFinalists} showWinner={showWinner} />
                        )
                    })}
                    {activeRegion === ALL_AREAS.id && !showFinalists && !showWinner && regionRestaurants.length > showAllCount && (
                        <button className="show-more-button" onClick={showMore}>Show more</button>
                    )}
                </div>
            </div>
        </section>
    );
}